import get from './methods/get';

export default {
	get: headers => get('bankAccountDetails', headers),
	emptyResponse: null,
};
